import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["source", "button"];

  copy() {
    const isHtml = this.element.dataset.clickToCopyType === "html";
    if (isHtml) {
      try {
        const tempElement = this.sourceTarget.cloneNode(true);
        tempElement.querySelectorAll("action-text-attachment").forEach(el => el.remove());
        tempElement.querySelectorAll(".attachment").forEach(el => el.remove());

        const html = tempElement.innerHTML;
        const text = tempElement.textContent;

        const blobHtml = new Blob([html], { type: "text/html" });
        const blobText = new Blob([text], { type: "text/plain" });

        const item = new ClipboardItem({
          "text/html": blobHtml,
          "text/plain": blobText
        });

        navigator.clipboard.write([item])
          .then(() => {
            this.showFeedback("Copied!");
          })
          .catch((err) => {
            this.showFeedback("Failed!");
            console.error("Could not copy HTML: ", err);
          });
      } catch (err) {
        this.showFeedback("Failed!");
        console.error("Error setting up copy HTML: ", err);
      }
    } else {
      const text = this.sourceTarget.textContent;
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.showFeedback("Copied!");
        })
        .catch((err) => {
          this.showFeedback("Failed!");
          console.error("Could not copy text: ", err);
        });
    }
  }

  showFeedback(message) {
    if (this.hasButtonTarget) {
      const originalText = this.buttonTarget.innerHTML;
      this.buttonTarget.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>${message}`;
      setTimeout(() => {
        this.buttonTarget.innerHTML = originalText;
      }, 2000);
    }
  }
}
